import heroImage from '@/assets/images/works/projects/hyperdrive/hyperdrive-logo.png'
import compareLeft from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-left.mp4'
import compareRight from '@/assets/images/works/projects/hyperdrive/hyperdrive--compare-right.png'

const framesModules = import.meta.glob(
  '/src/assets/images/works/projects/hyperdrive/hero-frames/*.png',
  { eager: true, import: 'default' }
)
const heroFrames = Object.keys(framesModules)
  .sort()
  .map((path) => framesModules[path])

export default {
  meta: {
    title: 'HYPERDRIVE',
    headline: 'Into the <br> <span class="text-electric-purple">Hyperspace.</span>',
    label: 'Case Study 02',
    description:
      'An immersive Sci-Fi themed portfolio, built with Vue 3 and light-speed animation.',
    chips: [
      { text: 'Portfolio', dotColor: 'bg-electric-purple' },
      { text: 'Creative Dev', dotColor: 'bg-blue-500' },
      { text: '2024' },
    ],
    heroImage: heroImage,
    heroFrames: heroFrames,
  },
  sidebar: {
    title: 'Index',
    meta: [
      { label: 'Client', value: 'Personal Project' },
      { label: 'Type', value: 'Web Portfolio' },
      { label: 'Role', value: 'Creative Developer' },
      { label: 'Stack', value: 'Vue 3, Tailwind CSS, GSAP, Canvas' },
      { label: 'Year', value: '2024' },
    ],
    cta: 'View Live Site',
    ctaLink: 'https://hyperdrive.juanlias.com',
    repoLink: 'https://github.com/juanlias/hyperdrive-portfolio',
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Overview',
      title: 'Project Brief',
      highlight:
        'Hyperdrive redefines personal branding by combining the power of Vue 3, Tailwind CSS, and GSAP into a Sci-Fi interface inspired by Star Wars.',
      cards: [
        {
          title: 'Hyperspace Intro',
          text: 'Canvas space travel simulation that generates immediate engagement from the first second.',
        },
        {
          title: 'Command',
          text: 'Retro-futuristic control panel with Glassmorphism aesthetic, neon borders, and visual haptic feedback.',
        },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Concept',
      label: 'Kyber System',
      title: 'Total Customization',
      description:
        'Inspired by lightsabers, the <strong>Kyber Crystal</strong> system allows real-time color palette switching (Ilum, Adegan, Hurrikaine) via holographic sweeps and energy cascades.',
      tags: ['Glassmorphism', 'Kyber Crystals', 'Holographic UI'],
    },
    problema: {
      id: 'problema',
      menuLabel: 'Performance',
      title: 'The Challenge',
      description:
        'Creating a visual "Wow" factor without sacrificing load speed. Balancing an experimental interface with complex accessibility systems and multilingual support (including Shavian).',
      stats: [
        { value: '5', label: 'Themes' },
        { value: '4', label: 'Languages' },
      ],
    },
    transformacion: {
      id: 'antesdespues',
      menuLabel: 'Comparison',
      title: 'Visual Calibration',
      beforeLabel: 'System Standby',
      afterLabel: 'Holographic Mode',
      instruction: 'Drag to scan',
      beforeImage: compareLeft,
      afterImage: compareRight,
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Tech Stack',
      title: 'Engineering',
      categories: [
        { name: 'Core', items: ['Vue 3', 'Vite', 'Vue I18n'] },
        { name: 'Animation', items: ['GSAP', 'Canvas API', 'WebGL'] },
        { name: 'Styles', items: ['Tailwind CSS', 'HugeIcons'] },
      ],
    },
    footer: {
      prev: { label: 'Previous Case', title: 'FinanzaFlow', link: '/works/finanza' },
      next: null,
    },
  },
}
